import React, {useMemo, Suspense, lazy, useRef} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'
import {connect} from 'react-redux'

import {isMobiles} from 'js/helpers/browser';
import ModulePreview from '../../components/ModulePreview';
import {filters} from '../../drupalSettings';
import filterChange from '../../actions/filterChange';
import {FILTER_ROOMS} from '../../constants';
import {convertRoomsToString} from '../../helpers';
import {pushFiltersApply, pushFiltersClose} from 'js/helpers/gtm';
import {useBrowser} from 'js/hooks/useBrowser';

import styles from './SearchModuleRooms.module.scss';

const ModuleRoomsForm = lazy(() => import('./components/ModuleRoomsForm'));

const cx = classnames.bind(styles);
const wordings = filters?.rooms || {};

const SearchModuleRooms = function ({
  dataUrl,
  className,
  activeFilter,
  filterChangeAction,
  onChange,
}) {
  const browser = useBrowser();
  const toglerRef = useRef(null);
  const previewLabel = useMemo(() => {
    return convertRoomsToString(dataUrl, wordings);
  }, [dataUrl, wordings])

  const isMobile = useMemo(function () {
    return isMobiles(browser);
  }, [browser])

  const isActive = useMemo(() => activeFilter === FILTER_ROOMS, [activeFilter])
  const previewValues = useMemo(function () {
    return [{
      label: wordings.label,
      value: previewLabel,
      readOnly: true,
    }]
  }, [previewLabel])

  const onFormSubmit = function (data) {
    onChange({
      apartment: data,
    }, FILTER_ROOMS)
    // TODO: SEARCH: fix gtm event tracking
    // pushFiltersApply('rooms')
    closeModal();
  }

  const onPreviewClick = function (e) {
    if (!isActive) {
      e?.preventDefault();
      filterChangeAction('activeFilter', FILTER_ROOMS);
    } else {
      onFormClose();
    }
  }

  const onFormClose = function () {
    pushFiltersClose('rooms');
    closeModal();
  }

  const closeModal = () => {
    filterChangeAction('activeFilter', null)
  }

  return (
    <div className={cx('root', className)}>
      <ModulePreview
        icon="PARTICIPANT"
        ref={toglerRef}
        values={previewValues}
        onClick={onPreviewClick}
      />
      {isActive && (
        <Suspense>
          <ModuleRoomsForm
            rooms={dataUrl}
            togler={toglerRef.current}
            onSubmit={onFormSubmit}
            isModalView={isMobile}
            onClose={onFormClose}
          />
        </Suspense>
      )}
    </div>
  )
}

SearchModuleRooms.propTypes = {
  dataUrl: PropTypes.arrayOf(PropTypes.object.isRequired),
  className: PropTypes.string,
  activeFilter: PropTypes.string,
  filterChangeAction: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
}

export default connect(({searchBox, url}) => ({
  dataUrl: url?.uiParams?.apartment,
  activeFilter: searchBox?.activeFilter,
}), {
  filterChangeAction: filterChange,
})(SearchModuleRooms);
